import FingoIcon from '../components/icons/FingoIcon';
import SantanderIcon from '../components/icons/SantanderIcon';
import getCdnUrl from '../helpers/get-cdn-url';

const SantanderImage = getCdnUrl(
  '/common_assets/assets/icons/santander_image.png',
);
const FingoImage = getCdnUrl('/common_assets/assets/icons/fingo_image.png');

export const REQUESTING_PLATFORM_TO_IMAGE_URL = {
  SANTANDER: SantanderImage,
  FINGO: FingoImage,
};

export const REQUESTING_PLATFORM_TO_ICON = {
  SANTANDER: SantanderIcon,
  FINGO: FingoIcon,
};

export const REQUESTING_PLATFORM_TO_CODES = {
  SANTANDER: 'SANTANDER',
  FINGO: 'FINGO',
  BCH: 'BCH',
  BCI_CORREDORES: 'BCI_CORREDORES',
  ITAU: 'ITAU',
};

export const REQUESTING_PLATFORM_TO_LABELS = {
  SANTANDER: 'Santander',
  FINGO: 'Fingo',
  BCH: 'Banco de Chile',
  ITAU: 'Itaú',
};

export const ALL_AVAILABLE_PLATFORMS_CODES = 'all';

export const AVAILABLE_REQUESTING_PLATFORMS_ENV_VARIABLE_NAME = 'REACT_APP_AVAILABLE_REQUESTING_PLATFORMS';

export const ACTIVE_REQUESTING_PLATFORM_ENV_VARIABLE_NAME = 'REACT_APP_ACTIVE_REQUESTING_PLATFORM';
